import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationsService } from '../../services/organizations.service';
import { PermissionsService } from '../../services/permissions.service';
import { Organization } from '../../models/organization.model';
import { MatCardModule } from '@angular/material/card';
import { RekbotSelectsService } from '../../services/rekbot-selects.service';
import { Integration } from '../../models/integration.model';
import { IntegrationsService } from '../../services/integrations.service';
import { ParamsListComponent } from '../params-list/params-list.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
import { of, Subscription } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { ImagesListComponent } from '../images-list/images-list.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-edit-integration',
  imports: [
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    ParamsListComponent,
    ImagesListComponent,
    MatSlideToggleModule,
    CommonModule,
    MatSelectModule
  ],
  templateUrl: './edit-integration.component.html',
  styleUrl: './edit-integration.component.css'
})
export class EditIntegrationComponent implements OnInit, OnDestroy {

  integrationId: number = 0;
  selectedUUID: string = "";

  editForm: FormGroup = new FormGroup({
    id: new FormControl(""),
    name: new FormControl(''),
    cardUuid: new FormControl(''),
    active: new FormControl(''),
  });

  currentIntegration: Integration = new Integration(0);

  $sss: any;

  integrationChanged$ = of(this.integrationsService.currentIntegration);

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public permissionsService: PermissionsService,
    public integrationsService: IntegrationsService,
    private authService: AuthService,
    //private rekbotSelects: RekbotSelectsService
  ) {
  }


  ngOnDestroy(): void {
    if(this.$sss instanceof Subscription){
      this.$sss.unsubscribe();
    }
    
  }
  ngOnInit(): void {
   

    this.fetchCards();

    this.integrationId = this.route.snapshot.params['integrationId'];

    console.log("integrationId", this.integrationId); 

    if (this.integrationId > 0) {
      this.integrationsService.fetchIntegration(this.integrationId)
        .subscribe({
          next: (response: any) => {
            console.log("integrationsService.fetchIntegration", response);
            this.integrationsService.setCurrentIntegration(response);// = response;
            this.$sss = this.integrationsService.integrationChanged().subscribe({
              next: (data: any) => {
                console.log("data", data);
                console.log("this.integrationsService", this.integrationsService.currentIntegration);
                this.editForm.patchValue({
                  id: this.integrationsService.currentIntegration.id,
                  name: this.integrationsService.currentIntegration.name,
                  cardUuid: this.integrationsService.currentIntegration.cardUuid,
                  active: this.integrationsService.currentIntegration.active
                });
                this.currentIntegration = this.integrationsService.currentIntegration;
              }
            });

            this.editForm.patchValue({
              id: this.integrationsService.currentIntegration.id,
              name: this.integrationsService.currentIntegration.name,
              cardUuid: this.integrationsService.currentIntegration.cardUuid,
              active: this.integrationsService.currentIntegration.active
            });
          },
          error: (error) => {
            console.log(error);
            if (error.status === 401) {
              this.authService.clearAuthData();
              this.router.navigate(['/login']);
            }
          }
        });
    } else {
      this.editForm.patchValue({
        id: 0,
        name: "",
        cardUuid: "",
        active: false
      });
    }
  }

  onSubmit() {
    console.log("submit")

    if (this.editForm.value.id === 0) {
      this.createIntegration();
    } else {
      this.updateIntegration();
    }
  }

  updateIntegration() {
    this.integrationsService.updateIntegration(this.editForm.value)
      .subscribe({
        next: (response: any) => {
          console.log("updateIntegration", response);
          this.router.navigate(['/integrations']);
        },
        error: (error: any) => {
          console.log(error);
          if (error.status === 401) {
            this.authService.clearAuthData();
            this.router.navigate(['/login']);
          }
        }
      });
  }

  createIntegration() {
    this.integrationsService.createIntegration(this.editForm.value)
      .subscribe({
        next: (response: any) => {
          console.log("createIntegration", response);
          this.router.navigate(['/integrations']);
        },
        error: (error: any) => {
          console.log(error);
          if (error.status === 401) {
            this.authService.clearAuthData();
            this.router.navigate(['/login']);
          }
        }
      });
  }

  fetchCards() {
    this.integrationsService.fetchCards()
      .subscribe({
        next: (data: any) => {
          this.integrationsService.integrationCards = data;
        },
        error: (error: any) => {
          console.error(error);
          if (error.status == 401) {
            this.authService.clearAuthData();
            this.router.navigate(['/login']);
          }
        }
      });
  }

  getTitle() {
    return this.integrationId == 0 ? "Dodaj" : "Edytuj";
  }

}
